import { MouseEventHandler, MouseEvent, PureComponent, ReactNode } from 'react';

import RelativeLink, { RelativeLinkProps } from 'src/components/relative-link';

export type OwnProps = {
  children?: ReactNode | null | undefined;
  // Allow styled-component style overrides
  className?: string;
  title: string;
  href: string;
  qaId?: string;
  isFocused?: boolean;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  disableNativeTooltip?: boolean;
  target?: RelativeLinkProps['target'];
};

type Props = OwnProps;

export class BasePullRequestLink extends PureComponent<Props> {
  linkRef: HTMLAnchorElement | null | undefined;

  componentDidUpdate(prevProps: OwnProps) {
    if (!this.linkRef) {
      return;
    }

    if (!prevProps.isFocused && this.props.isFocused) {
      this.linkRef.focus();
      return;
    }

    if (prevProps.isFocused && !this.props.isFocused) {
      this.linkRef.blur();
    }
  }

  render() {
    const {
      children,
      className,
      href,
      title,
      qaId,
      disableNativeTooltip,
      target,
    } = this.props;
    const content = children || title;
    const onClick = (event: MouseEvent<HTMLAnchorElement>) => {
      if (this.props.onClick) {
        this.props.onClick(event);
      }
    };

    const linkTitle = !disableNativeTooltip ? title : undefined;

    /* eslint-disable no-return-assign */
    return (
      <RelativeLink
        innerRef={node => (this.linkRef = node)}
        to={href}
        data-qa={qaId}
        className={className}
        title={linkTitle}
        onClick={onClick}
        target={target}
      >
        {content}
      </RelativeLink>
    );
    /* eslint-enable no-return-assign */
  }
}

// eslint-disable-next-line import/no-default-export
export default BasePullRequestLink;
